export default "__VITE_ASSET__Dg$CeQTr__";